<tcm-main-frame titleKey="Screens.Patients.InfoWidget.PatientAlertsShowUp.Title">
  <ng-container commands>
    <button *ngIf="canEdit"
            class="btn btn-complete me-2"
            (click)="completeAll()">{{'Screens.Patients.InfoWidget.PatientAlertsShowUp.Actions.CompleteAll' | translate}}</button>
    <button class="btn btn-default"
            (click)="goBack()">{{'Common.SearchActionsAndDetailsActions.Cancel' | translate}}</button>
  </ng-container>
  <ng-container body>
    <div *ngFor="let alert of alerts" class="alert alert-warning" role="alert">
      <span class="alert-text">{{alert.message}}</span>
      <div class="row">
        <div class="col-sm-12 text-end">
          <button *ngIf="canEdit"
                  class="btn btn-complete"
                  (click)="complete(alert.id)">{{'Screens.Patients.InfoWidget.PatientAlertsShowUp.Actions.Complete' | translate}}</button>
        </div>
      </div>
    </div>
  </ng-container>
</tcm-main-frame>